import React from 'react'



const TextGlobe = ({text, position, textSize}) => {

    const globeStyle = {
        position: 'absolute',
        top: position,
        left: position,
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        fontSize: textSize,
        padding: `calc(${textSize} * 0.5)`,
        borderRadius: textSize
    }

  return (
    <div className='text-globe' style={ globeStyle }>{ text }</div>
  )
}

export default TextGlobe